export default __webpack_public_path__ + "static/media/rootity.ae9a726d.gif";